export const IconVacancyItemBold: {
  name: 'icon_vacancy_item_bold-b83e49384b7c'
} = {
  name: 'icon_vacancy_item_bold-b83e49384b7c'
}
